import { getDataStoreEntityMap } from '../../../modules/chat/dataStoreEntityMap'

const selectDevices = state => getDataStoreEntityMap(state.data.devices)

const DeviceDataStoreSelectors = {
  devices: selectDevices
}

export default DeviceDataStoreSelectors
